import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  Grid,
  Box,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  CircularProgress,
} from '@mui/material';
import DownloadIcon from '../../../assets/icons/download-icon';
import TimeRange from '../../../components/time-range';
import { QueryParameterKeys } from '../../../globals/paramter';
import { AppState } from '../../../store';
import { getVimsSFTPReportAction } from '../../../store/vims-sftp-files/actions';
import useStyles from './styles';

const Reports = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const classes = useStyles();
  const fileId = useSelector((state: AppState) => state.vimsSFTPReport.fileId);
  const isLoading = useSelector((state: AppState) => state.vimsSFTPReport.isLoading);
  const [reportTypeValue, setReportTypeValue] = useState<string>('totalByDealer');

  const parameters: URLSearchParams = new URLSearchParams(location.search);
  const startTime = parameters.get(QueryParameterKeys.startTime) || undefined;
  const endTime = parameters.get(QueryParameterKeys.endTime) || undefined;

  const reportTypes = [
    { value: 'totalBySerialNumber', label: 'Serial Number' },
    { value: 'totalByDealer', label: 'Dealer / Customer' },
  ];

  const handleVimsSFTPReport = () => {
    const input = {
      startTime,
      endTime,
      reportType: reportTypeValue,
    };
    dispatch(getVimsSFTPReportAction(input));
  }

  return (
    <div className={classes.scrollBox}>
      <Grid container>
        <Box ml={1} mr={1}>
          <RadioGroup
            row
            value={reportTypeValue}
            onChange={(event) => setReportTypeValue(event.target.value)}
          >
            {reportTypes.map((reportType) => (
              <FormControlLabel value={reportType.value} control={<Radio />} label={reportType.label} />
            ))}
          </RadioGroup>
        </Box>
        <TimeRange blockFutureDates />

        <Button
          className={classes.button}
          onClick={() => handleVimsSFTPReport()}
          variant="outlined"
          size="small"
          endIcon={isLoading ? <CircularProgress size={20} /> : <DownloadIcon />}
          disabled={isLoading}
        >
          <Typography variant="button">
            {isLoading ? 'Processing Report' : 'Download Report'}
          </Typography>
        </Button>

        {fileId}
      </Grid>
    </div>
  );
};

export default Reports;
